import { primitive } from 'styles/constants';
export default {
  subTextColor: primitive.$greyOne,
  progressFillColor: primitive.$fieryRed,
  freeDeliveryTitleColor: primitive.$fieryRed,
};
